import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ADMIN, ENUMS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const PackagesList = () => {
	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'ID', filterType: FilterType.number, width: 50 },
			{ Header: 'packageName', accessor: 'packageName', filterType: FilterType.string },
			{
				Header: 'country',
				accessor: 'country',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.COUNTRIES,
				filterPrefix: 'country.',
				renderCell: ListComponents.COUNTRY,
				width: 200
			},
			{ Header: 'monthlyPrice', accessor: 'monthlyPrice', filterType: FilterType.float },
			{ Header: 'monthlyDiscount', accessor: 'monthlyDiscount', filterType: FilterType.float },
			{ Header: 'yearlyPrice', accessor: 'yearlyPrice', filterType: FilterType.float },
			{ Header: 'yearlyDiscount', accessor: 'yearlyDiscount', filterType: FilterType.float },
			{ Header: 'currency', accessor: 'currency', filterType: FilterType.string },
			{ Header: 'packageRoleId', accessor: 'packageRoleID', filterType: FilterType.string },
			{
				Header: 'defaultModuleIds',
				accessor: 'defaultModuleIds',
				filterType: FilterType.string
			},
			{
				Header: 'infoJson',
				accessor: 'infoJson',
				filterType: FilterType.string
			},
			{
				Header: 'dailyPrice',
				accessor: 'dailyPrice',
				filterType: FilterType.number
			},
			{
				Header: 'tier',
				accessor: 'tier',
				filterType: FilterType.string
			}
		],
		[]
	);
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);
	return (
		<DynamicList
			id={DYNAMICLISTS.PACKAGES}
			columns={columns}
			defaultSort={defaultSort}
			fetchUrl={ADMIN.CONFIGURATION.GET_PACKAGES_LIST}
			actionObjectType={ACTION_OBJECT_TYPES.ADMIN}
		/>
	);
};
export default PackagesList;
